export class PageDto {
    data: any;
    meta: Meta;
}
  
export class Meta {
    totalPages: number;

    public static fromJson(json: Object): Meta {
        return new Meta()
          .setTotalPages(json['totalPages']);
    }

    setTotalPages(totalPages: number) {
        this.totalPages = totalPages;
        return this;
    }
}